export const notificationQueueHeaderTitleStyle = {
  display: 'inline',
  fontSize: '20px',
  height: 'auto',
  lineHeight: '27px',
  width: 'auto',
};
